<div class="flex flex-column" style="width: 100%">
  <div *ngIf="results" class="flex justify-content-between">
    <!-- full width row -->
    <div style="flex: 1">
      <div>{{ tableName }}</div>
    </div>
    <div class="text-center" style="flex: 1">
      <!-- TODO ADD DROPDOWN FOR PAGE NUMBER -->
      Page {{ this.results.page }} of {{ this.results.totalPages }}
    </div>
    <div class="text-right" style="flex: 1">
      <button
        pButton
        pRipple
        type="button"
        icon="pi pi-refresh"
        class="p-button-rounded p-button-text"
        (click)="refresh()"
      ></button>
      <!-- TODO ADD SEARCH -->
      <button
        *ngIf="false"
        pButton
        pRipple
        type="button"
        icon="pi pi-search"
        class="p-button-rounded p-button-text"
        (click)="search()"
      ></button>

      <!-- add a little gear button so people can configure it -->
      <!-- PAGE SIZE -->
      <p-dropdown
        (onChange)="handlePageSize($event)"
        [ngModel]="pageSize"
        [options]="pageSizes"
      ></p-dropdown>
    </div>
  </div>
  <div *ngIf="results" class="flex justify-content-between">
    <!-- row with three divs spaced between -->
    <div style="flex: 1">
      <button
        pButton
        pRipple
        type="button"
        icon="pi pi-angle-double-left"
        class="p-button-rounded p-button-text"
        [disabled]="this.results.page === 1"
        (click)="changePage(1)"
      ></button>
      <button
        pButton
        pRipple
        type="button"
        icon="pi pi-angle-left"
        class="p-button-rounded p-button-text"
        [disabled]="this.results.page === 1"
        (click)="changePage(this.results.page - 1)"
      ></button>
      <!-- TODO loop the next three pages -->
    </div>
    <div class="text-center" style="flex: 1">
      <small>({{ this.results.totalItems }} records found)</small>
    </div>
    <div class="text-right" style="flex: 1">
      <!-- TODO loop the previous three pages -->
      <button
        pButton
        pRipple
        type="button"
        icon="pi pi-angle-right"
        class="p-button-rounded p-button-text"
        [disabled]="this.results.page === this.results.totalPages"
        (click)="changePage(this.results.page + 1)"
      ></button>
      <button
        pButton
        pRipple
        type="button"
        icon="pi pi-angle-double-right"
        class="p-button-rounded p-button-text"
        [disabled]="this.results.page === this.results.totalPages"
        (click)="changePage(this.results.totalPages)"
      ></button>
    </div>
  </div>
</div>
